// extracted by mini-css-extract-plugin
export default {"star_rating":"StarRating_star_rating__0dUJG","star":"StarRating_star__Vh+C-","active":"StarRating_active__OaSeK","rating_text":"StarRating_rating_text__hzXij"};